import { t } from '../i18n';
import {
    containsOneOf,
    Example,
    isEmptyExample,
    markers,
    quotedReserved,
    quotedTriggers,
    reservedWords,
    triggers,
} from '../models/common';

const validateStructuredExample = (value: Example, activationPhrases: string[], isAdmin?: boolean): string => {
    if (!value || isEmptyExample(value)) {
        return '';
    }
    if (!value.marker) {
        return t('example-marker');
    }
    if (!value.activationPhrase) {
        return t('example-phrase');
    }

    const hasMarkerWithRequest = Boolean(markers.find((m) => m.text === value.marker && m.hasRequest));
    if (hasMarkerWithRequest && !value.request) {
        return t('example-request');
    }
    if (containsOneOf(value.request, triggers)) {
        return t('example-contains-trigger', { words: quotedTriggers });
    }
    if (!isAdmin && containsOneOf(value.request, reservedWords.inflected)) {
        return t('example-contains-reserved', { words: quotedReserved });
    }
    if (containsOneOf(value.request, activationPhrases)) {
        return t('example-contains-activation');
    }

    return '';
};

export default validateStructuredExample;
